import request from '@/utils/request';

// 客户
export function memberList(params) {
  return request({ url: `/member/getList`, method: 'get', params })
}
export function memberType(params) {
  return request({ url: `/member/type/getList`, method: 'get', params })
}
export function memberbuyLog(params) {
  return request({ url: `/member/buyLog/getList`, method: 'get', params })
}
export function memberTypeCreate(data) {
  return request({ url: `/member/type/add`, method: 'post', data })
}

export function memberTypeUpdate(data) {
  return request({ url: `/member/type/add`, method: 'post', data })
}

export function memberBuyCreate(data) {
  return request({ url: `/member/buy`, method: 'post', data })
}
export function memberBuyUpdate(data) {
  return request({ url: `/member/buy`, method: 'post', data })
}

